import styled from "styled-components";

export const StyledListItem = styled.div`
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & .earning-wrapper {
    display: flex;
    align-items: center;
    padding-right: 5px;
  }
  & .earning-text {
    color: ${({ theme }) => theme.palette.text.secondary};
    margin: 0;
    overflow: hidden;
    white-space: nowrap;
    display: block;
    font-size: 14px !important;
    font-weight: 500;

    width: 100%;
    /* & > .muitypography-root {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: '100%';
    } */
  }
  & .dot-icon {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
  }
`;

export const StyledEarningGraphWrapper = styled.div`
  position: relative;
  display: block;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  margin-left: -8px;
  margin-right: -8px;
  width: -webkit-fill-available;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
    flex-direction: row;
  }

  & text {
    fill: ${({ theme }) => theme.palette.text.primary};
  }
  & .earning-item {
    height: 100%;
    width: 100%;
    display: flex;
    gap: 10px;
    padding-left: 8px;
    padding-right: 8px;
    justify-content: center;
    align-items: center;

    .recharts-responsive-container {
      width: 100% !important;
      height: 100% !important;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px;

      .recharts-responsive-container .recharts-wrapper {
        width: 100% !important;
        height: 100% !important;
      }
    }
  }
  & .earning-graph-item {
    padding-left: 0;
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
      width: 54%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
      width: 55%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
      width: 50%;
    }
  }
`;
